import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';
import { t } from '../lib/i18n.js';
import { readSession } from '../lib/session.js';

export default function Connect() {
  const navigate = useNavigate();
  const [session] = useState(() => readSession());
  const lang = session.language || 'en';

  useEffect(() => {
    if (!session.submittedAt) navigate('/start', { replace: true });
  }, [session.submittedAt, navigate]);

  return (
    <section className="mx-auto max-w-xl px-6 py-20 text-center">
      <div className="mx-auto h-16 w-16 rounded-full border border-alfred-gold/60 grid place-items-center">
        <PhoneCall className="h-7 w-7 text-alfred-gold animate-pulse" />
      </div>
      <h1 className="mt-8 text-3xl md:text-5xl font-serif leading-tight">
        {t(lang, 'connectTitle')}
      </h1>
      <p className="mt-5 text-stone-300">{t(lang, 'connectSub')}</p>
      <p className="mt-6 text-sm text-stone-500">{t(lang, 'connectMeta')}</p>
    </section>
  );
}
